import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
// import { environment } from '../../../../../projects/administration/src/environments/environment';
import { LogEntryModel } from '../../../models/logentry';
import { EnvironmentService } from '../../../../app/services/environment.service';

@Injectable({
  providedIn: 'root'
})

export class LogService {

constructor(
              private httpClient: HttpClient,
              private environment: EnvironmentService
  ) {
}

public SaveLogError(entry: LogEntryModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};

    return this.httpClient.post<LogEntryModel>(`${this.environment.getApiURL()}/api/logerror`, entry , options);

  }

private isExists(item: any): boolean {
  if (typeof item !== 'undefined') {
    return true;
  }
  return false;
}

}

